import { useState } from "react";
import {
  BudgetSection,
  CreditSection,
  IntroSection,
  StockSection,
} from "../components/layout/SpreadsheetsPage";
import { PopUp } from "../components/UI/PopUp";
import { Typography } from "../components/UI/Typography";

export const SpreadsheetsPage = () => {
  const [spreadsheetName, setSpreadsheetName] = useState("Default Spreadsheet");
  const [popupTitle, setPopupTitle] = useState("");
  const [popupSubtitle, setPopupSubtitle] = useState("");
  const [isPopup, setIsPopup] = useState(true);
  const [isShowNotification, setShowNotification] = useState(false);

  const handleClick = () => {
    const element = document.getElementsByClassName("credit-container")[0];
    element?.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  const toggleNoti = () => {
    setShowNotification(true);
    // Hide popup after 4 seconds
    setTimeout(() => {
      setShowNotification(false);
    }, 4000);
  };

  const togglePopup = (event) => {
    const downloadButton = event.target;
    // console.log("downloadButton element: ", downloadButton);

    if (downloadButton.classList.contains("credit-download-button")) {
      setSpreadsheetName("Credit Card Spreadsheet");
    } else if (downloadButton.classList.contains("stock-download-button")) {
      setSpreadsheetName("Stock Intrinsic Value Calculator");
    } else if (downloadButton.classList.contains("budget-download-button")) {
      setSpreadsheetName("Budget Spreadsheet");
    }

    const element = document.getElementsByClassName("popup-background")[0];

    if (element.style.display === "none") {
      element.style.display = "block";
    } else {
      element.style.display = "none";
    }
  };

  return (
    <div className="bg-beige-prim pt-20 flex flex-col gap-0 md:gap-10 lg:gap-20">
      <IntroSection handleClick={handleClick} />
      <CreditSection togglePopup={togglePopup} />
      <StockSection togglePopup={togglePopup} />
      <BudgetSection togglePopup={togglePopup} />
      <PopUp
        title={spreadsheetName}
        subtitle="By clicking ' I'm In ', you will get the spreadsheet for free and agree to subscribe to my email newsletter all about making more money and living a richer life."
        subtitle2="No pressure, you can unsubscribe anytime."
        togglePopup={togglePopup}
        toggleNoti={toggleNoti}
      />
      {/* <button onClick={toggleNoti}>Toggle Notification</button> */}
      <div
        className="fixed inset-0 flex items-center justify-center z-50"
        style={{
          display: isShowNotification ? "flex" : "none",
          transition: "opacity 0.3s ease-in-out",
        }}
      >
        <div
          style={{
            boxShadow: "12px 12px #ff3131",
          }}
          className="bg-beige-prim border-[3px] border-black pt-5 md:pt-10 pb-10 md:pb-14 px-5 md:px-10 rounded-3xl shadow-lg max-w-2xl w-full text-center"
        >
          <Typography variant="h3">
            Your file should have automatically downloaded.
          </Typography>
          <Typography>
            If that didn't happen, please turn off your ad blocker or check your
            email spam folder in a few minutes.
          </Typography>
        </div>
      </div>
    </div>
  );
};
